module.exports = __webpack_public_path__ + "img/ERIC_MISKA.f4f84701.png";